import UpgradeService from '@/services/upgrade'
import * as types from '../mutations'

const state = {
  bannerVisible: false
}

const getters = {
  isBannerVisible: (state) => state.bannerVisible
}

const actions = {
  async updatePlan ({ commit }, { plan }) {
    try {
      await UpgradeService.updatePlan(plan)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  async cancelPlan ({ commit }) {
    try {
      await UpgradeService.cancelPlan()
    } catch (error) {
      return Promise.reject(error)
    }
  },
  async pausePlan ({ commit }) {
    try {
      await UpgradeService.pausePlan()
    } catch (error) {
      return Promise.reject(error)
    }
  },
  async resumePlan ({ commit }) {
    try {
      await UpgradeService.resumePlan()
    } catch (error) {
      return Promise.reject(error)
    }
  },
  async undoPendingChange ({ commit }) {
    try {
      await UpgradeService.undoPendingChange()
    } catch (error) {
      return Promise.reject(error)
    }
  },
  async getPaddleManagementLink ({ commit }) {
    try {
      const res = await UpgradeService.getPaddleManagementLink()
      return Promise.resolve(res)
    } catch (error) {
      return Promise.reject(error)
    }
  }
}

const mutations = {
  [types.SET_BANNER_VISIBILITY] (state, visible) {
    state.bannerVisible = visible
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
